import React, {createContext, useState} from 'react';

type ControlledFormProps = {
    initialValues: Object,
    onSubmit: (event: any, formData: any) => void,
    children: React.ReactNode
}

type ControlledFormContextProps = {
    handleFormChange: (event: any) => void,
    changeInput: (name: string, value: any) => void,
    setFormData:  React.Dispatch<React.SetStateAction<Object>>
    formData: any
}

export const ControlledFormContext = createContext<ControlledFormContextProps>({
    handleFormChange: () => {},
    changeInput: () => {},
    setFormData: () => {},
    formData: {}
})

const ControlledForm: React.FC<ControlledFormProps> = (props) => {
    const {initialValues, children, onSubmit} = props
    const [formData, setFormData] = useState(initialValues)

    const handleFormChange = (event: any) => {
        const {name, value} = event.target;
        changeInput(name, value)
    }

    const changeInput = (name: string, value: any) => {
        setFormData(prevState => {
            const newState = {...prevState, [name]: value}
            if (value === undefined) { // @ts-ignore
                delete newState[name]
            }
            return newState
        })
    }

    return (
        <ControlledFormContext.Provider value={{handleFormChange, changeInput, setFormData, formData}}>
            <form className="molekuls-four-controlledform" onSubmit={(event) => onSubmit(event, formData)}>
                {children}
            </form>
        </ControlledFormContext.Provider>

    );
}

export default ControlledForm;
